import {
  AdminAppAction,
  CreatePlaceErrorAction,
  CreatePlaceRequestAction,
  CreatePlaceSuccessAction,
  PlaceActionType,
  createPlaceError,
  createPlaceSuccess,
} from '../../actions';
import {
  CREATE_PLACE_MUTATION,
  CreatePlacePayload,
  CreatePlaceVariables,
} from '../../mutations';
import { Epic, ofType } from 'redux-observable';
import { AdminAppState } from '../../state';
import { EpicDependencies } from '../epic-dependencies';
import { Observable } from 'rxjs';
import { getCreatePlaceInput } from '../../selectors';
import { switchMap } from 'rxjs/operators';

export const createPlaceEpic: Epic<
  AdminAppAction,
  CreatePlaceSuccessAction | CreatePlaceErrorAction,
  AdminAppState,
  EpicDependencies
> = (
  action$,
  state,
  { client },
): Observable<CreatePlaceSuccessAction | CreatePlaceErrorAction> =>
  action$.pipe(
    ofType<AdminAppAction, CreatePlaceRequestAction>(
      PlaceActionType.CreatePlaceRequest,
    ),
    switchMap(async (action: CreatePlaceRequestAction) => {
      const { data, errors } = await client.mutate<
        CreatePlacePayload,
        CreatePlaceVariables
      >({
        errorPolicy: 'all',
        mutation: CREATE_PLACE_MUTATION,
        variables: {
          input: getCreatePlaceInput(action.placeKey)(state.value),
        },
      });

      if (errors) {
        return createPlaceError(action.placeKey, errors);
      } else if (data) {
        return createPlaceSuccess(action.placeKey);
      } else {
        throw new Error('No data.');
      }
    }),
  );
